<template>
  <div class="main">

    <div
      class="main__others"
      v-if="a7stateMap.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in a7stateMap"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span class="value" :class="{alarm:alarm.includes(item.value)}">{{item.value}}</span>
        </li>
      </ul>
    </div>

    <div
      class="main__list"
      v-if="a8stateMap.length>0"
    >
      <ul>
        <li
          :title="item.title+':'+item.value"
          v-for="(item, index) in a8stateMap"
          :key="index"
        >
          <span class="title">{{item.title}}: </span>
          <span class="value" :class="{alarm:alarm.includes(item.value)}">{{item.value}}</span>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      a7stateMap: [
        { title: "电池低温报警", value: "--" },
        { title: "电池超温", value: "--" },
        { title: "均衡状态", value: "--" },
        { title: "电池掉线", value: "--" },
        { title: "充电保护失效", value: "--" },
        { title: "放电保护失效", value: "--" }
      ],
      a8stateMap: [
        { title: "充电过流报警", value: "--" },
        { title: "充电MOS管故障", value: "--" },
        { title: "充电MOS管状态	", value: "--" },
        { title: "放电MOS管故障", value: "--" },
        { title: "放电MOS管状态", value: "--" },
        { title: "放电过流报警", value: "--" },
        { title: "低容量报警", value: "--" },
        { title: "功率板超温报警", value: "--" }
      ],
      alarm: [
        "低温",
        "超温",
        "掉线",
        "失效",
        "报警",
        "关闭",
        "关"
      ]
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        const { a7stateMap, a8stateMap } = val;
        if (a7stateMap != undefined) {
          const {
            BatteryLowTemperature,
            BatteryOverheating,
            balancedState,
            batteryDropping,
            chargingProtectionFailure,
            disChargingProtectionFailure
          } = a7stateMap;
          this.a7stateMap = [
            {
              title: "电池低温报警",
              value: this.dataFormat(
                BatteryLowTemperature,
                [0],
                "正常",
                [1],
                "低温"
              )
            },
            {
              title: "电池超温",
              value: this.dataFormat(
                BatteryOverheating,
                [0],
                "正常",
                [1, 2],
                "超温"
              )
            },
            {
              title: "均衡状态",
              value: this.dataFormat(balancedState, [1], "开", [0], "关")
            },
            {
              title: "电池掉线",
              value: this.dataFormat(batteryDropping, [1], "正常", [0], "掉线")
            },
            {
              title: "充电保护失效",
              value: this.dataFormat(
                chargingProtectionFailure,
                [1],
                "失效",
                [0],
                "正常"
              )
            },
            {
              title: "放电保护失效",
              value: this.dataFormat(
                disChargingProtectionFailure,
                [1],
                "失效",
                [0],
                "正常"
              )
            }
          ];
        }
        if (a8stateMap != undefined) {
          const {
            chargeOver,
            chargingMosAlarm,
            chargingMosState,
            disChargingMosAlarm,
            disChargingMosState,
            dischargeOver,
            lowCapacity,
            powerBoardOvertemperature
          } = a8stateMap;
          this.a8stateMap = [
            {
              title: "充电过流报警",
              value: this.dataFormat(
                chargeOver,
                [1],
                "报警",
                [0],
                "正常"
              )
            },
            {
              title: "充电MOS管故障",
              value: this.dataFormat(chargingMosAlarm, [1], "报警", [0], "正常")
            },
            {
              title: "充电MOS管状态	",
              value: this.dataFormat(chargingMosState, [1], "开启", [0], "关闭")
            },
            {
              title: "放电MOS管故障",
              value: this.dataFormat(
                disChargingMosAlarm,
                [1],
                "报警",
                [0],
                "正常"
              )
            },
            {
              title: "放电MOS管状态",
              value: this.dataFormat(
                disChargingMosState,
                [1],
                "开启",
                [0],
                "关闭"
              )
            },
            {
              title: "放电过流报警",
              value: this.dataFormat(
                dischargeOver,
                [1],
                "报警",
                [0],
                "正常"
              )
            },
            {
              title: "低容量报警",
              value: this.dataFormat(lowCapacity, [1], "报警", [0], "正常")
            },
            {
              title: "功率板超温报警",
              value: this.dataFormat(
                powerBoardOvertemperature,
                [1],
                "报警",
                [0],
                "正常"
              )
            }
          ];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    dataFormat(data, arr1, str1, arr2, str2) {
      if (arr1.indexOf(data) != -1) {
        return str1;
      } else if (arr2.indexOf(data) != -1) {
        return str2;
      }
      return "--";
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  &__others {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 20%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  &__list {
    padding: 10px 0;
    display: flex;
    flex: 1;
    border-bottom: 1px solid rgb(216, 217, 218);
    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 25%;
        padding: 10px 0;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .title {
          font-size: 14px;
          color: #999999;
        }
        .value {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
.alarm {
  color: red !important;
}
</style>